import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { fetchAvailableFeatures } from '../../redux/slices/institutionSlice';
import config from "../../config/config";
import { Link, useLocation } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Collapse from 'react-bootstrap/Collapse';
import '../../component/componentCss/sidebar.css'
import {
  getFormsAction,
  getMasterListAction,
  getCategoriesAction,
  getDepartmentsAction,
  getDepartmentFormsTypeAction
} from "../../Action/admin.action";
import {
  BsGrid,
  BsPeople,
  BsPersonPlusFill,
  BsFileEarmarkCodeFill,
  BsFillPeopleFill,
  BsPersonBadgeFill,
  BsList,
  BsFileText,
  BsFolder,
  BsChevronDown,
  BsFillGearFill,
  BsCardList,
  BsHospital,
  BsBarChart,
  BsStars,
  BsDownload,
  BsPrescription2,
  BsBuilding
} from "react-icons/bs";
import { GrSchedule } from "react-icons/gr";
import { TbReportMedical } from "react-icons/tb";

import { capitalizeFirstWord } from "../../config/conversion"
import Cookies from "js-cookie";
import { DropdownItem } from "react-bootstrap";
import { FaHistory, FaClipboardList } from "react-icons/fa";
import { MdNotificationsActive } from "react-icons/md";
import { decryptData } from './decrypt';
import propertise from "../../config/properties";
import FeatureGuard from '../../components/common/FeatureGuard';

const Sidebar = () => {
  var pageURL = window.location.href;
  var lastURLSegment = pageURL.substr(pageURL.lastIndexOf("/") + 1);

  const [formList, setFormList] = useState([]);
  const [departmentFormList, setDepartmentFormList] = useState([]);
  const [formCategoryList, setFormCategoryList] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [departmentMenus, setDepartmentMenus] = useState([]);
  const [open, setOpen] = useState(false);
  const [openPermission, setOpenPermission] = useState(false);
  const [openUserManagement, setopenUserManagement] = useState(false);
  const [openUserManagementCms, setopenUserManagementCms] = useState(false);


  const [formsOpen, setFormsOpen] = useState(false);
  const [openDepartment, setOpenDepartment] = useState(false);
  const [departmentFormId, setDepartmentFormId] = useState(0);
  const [openReporting, setOpenReporting] = useState(false);

  // Fix storage mismatch: read from localStorage instead of cookies
  // Also add role mapping for string roles from new backend
  let loginData = null;
  try {
    const storageData = localStorage.getItem("loginSuccessNeurulaHealth");
    if (storageData) {
      loginData = JSON.parse(storageData);

      // Map string roles to numeric roles for compatibility
      if (loginData?.role && typeof loginData.role === 'string') {
        const roleMapping = {
          'super_admin': 1,
          'admin': 2,
          'super_user': 1,
          'administrator': 2,
          'nurse': 3,
          'doctor': 4,
          'physician': 4
        };
        loginData.numericRole = roleMapping[loginData.role.toLowerCase()] || loginData.role;
        loginData.stringRole = loginData.role.toLowerCase();
      } else {
        loginData.numericRole = loginData?.role;
        loginData.stringRole = loginData?.role;
      }

      // Ensure roles array exists for RBAC checks
      if (!loginData.roles) {
        loginData.roles = [];
      }
    }
  } catch (error) {
    loginData = null;
  }

  // Helper function to check if user has a specific role (legacy or RBAC)
  const hasRole = (roleToCheck) => {
    if (!loginData) return false;
    
    // Check legacy role (string comparison)
    const hasLegacyRole = loginData.stringRole === roleToCheck.toLowerCase();
    
    // Check RBAC roles array
    const hasRbacRole = loginData.roles && loginData.roles.includes(roleToCheck.toLowerCase());
    
    return hasLegacyRole || hasRbacRole;
  };

  // Helper function to check if user is admin/super admin
  const isAdmin = () => {
    return loginData?.numericRole == 1 || loginData?.numericRole == 2 || hasRole('admin') || hasRole('super_admin');
  };

  // Helper function to check if user is clinical staff (nurse, doctor, physician)
  const isClinicalStaff = () => {
    return hasRole('nurse') || hasRole('doctor') || hasRole('physician');
  };

  // Helper function to check if user can access Consents tab (nurse, nurse_manager, admin)
  const canAccessConsents = () => {
    return isAdmin() || hasRole('nurse') || hasRole('nurse_manager');
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAvailableFeatures());
  }, [dispatch]);

  useEffect(() => {
    getFormListAPI();

    if (lastURLSegment == 'isPatiendSearch') {
      getFormTypesListAPI()
    }

    // Add simple auth test
    testAuthAPI();
  }, []);

  // Simple test to verify authentication is working
  const testAuthAPI = async () => {
    try {
      const res = await getDepartmentsAction();
    } catch (error) {
    }
  };

  const handleClick = () => {
    setOpenPermission(!openPermission);
  };

  const handleClickUserManagement = () => {
    setopenUserManagement(!openUserManagement);
  };

  const handleClickUserManagementCms = () => {
    setopenUserManagementCms(!openUserManagementCms)
  }

  let getFormListAPI = async () => {
    let res = await getFormsAction();
    if (res.success) {
      setFormList(res.data);
    }
  };

  let getDepartmentMenuesAPI = async () => {
    let res = await getDepartmentsAction();
    if (res.success) {
      setDepartmentMenus(res.data); // Modern endpoint doesn't need decryption
    }
  };

  let getFormCategoryAPI = async () => {
    let res = await getCategoriesAction();
    if (res.success) {
      setFormCategoryList(res.data); // Modern endpoint doesn't need decryption
    }
  };

  let getMasterData = async () => {
    let res = await getMasterListAction();
    if (res.success) {
      setMasterData(res.data);
    } else {
      setMasterData([]);
    }
  };

  let getFormTypesListAPI = async () => {
    let MRNNumber = localStorage.getItem('mrnNumber');
    let res = await getDepartmentFormsTypeAction({ 'MRNNumber': MRNNumber });
    if (res.success) {
      let data = decryptData(res.data)
      setDepartmentFormList(data);
    }
  };

  return (
    <>
      <nav id="sidebar">
        <div className="sideinr pt-4">
          <div className="sidebar_logo d-none">
            <span>
              <img
                src="assets/images/mainlogo.png"
                className="mainlogo"
                alt="mainlogo"
              />
            </span>
          </div>
          <ul className="me-auto">
            {isAdmin() ? (
              <>
                <li className={lastURLSegment == "dashboard" ? "active" : ""}>
                  <Link to={`${config.baseUrl}dashboard`} className="nav-link ">
                    <span>
                      <BsGrid />
                    </span>
                    Dashboard
                  </Link>
                </li>

                <li>
                  <Link to="#" className="nav-link">
                    <div className="d-flex flex-row align-items-center">
                      <span>
                        <BsPersonBadgeFill />
                      </span>
                      <p
                        className="mb-0 pe-5"
                        onClick={handleClickUserManagement}
                        aria-controls="example-collapse-text"
                        aria-expanded={openUserManagement}
                      >
                        User Management
                      </p>
                      <BsChevronDown />
                    </div>
                  </Link>
                </li>

                <Collapse in={openUserManagement}>
                  <div id="example-collapse-text-1">
                    <li className={lastURLSegment === "staff-management" ? "active" : ""}>
                      <Link to={`${config.baseUrl}staff-management`} className="nav-link">
                        <span>
                          <BsList />
                        </span>Users List
                      </Link>
                    </li>
                    <li className={lastURLSegment === "duty-schedule" ? "active" : ""}>
                      <Link to={`${config.baseUrl}duty-schedule`} className="nav-link">
                        <span>
                          <BsList />
                        </span>Duty Schedule
                      </Link>
                    </li>
                    <li className={lastURLSegment === "UserPermissions" ? "active" : ""}>
                      <Link to={`${config.baseUrl}UserPermissions`} className="nav-link">
                        <span>
                          <BsList />
                        </span>User Permission
                      </Link>
                    </li>
                    <li className={lastURLSegment === "rolesPermission" ? "active" : ""}>
                      <Link to={`${config.baseUrl}rolesPermission`} className="nav-link">
                        <span>
                          <BsList />
                        </span>Roles Permission
                      </Link>
                    </li>
                    <li className={
                      lastURLSegment == "user-group" ||
                        lastURLSegment == "add-user-group"
                        ? "active"
                        : ""
                    }>
                      <Link to={`${config.baseUrl}user-group`} className="nav-link">
                        <span>
                          <BsList />
                        </span>Roles
                      </Link>
                    </li>
                  </div>

                </Collapse>
                <li
                  className={
                    lastURLSegment == "department-list" ? "active" : ""
                  }
                >
                  <Link
                    to={`${config.baseUrl}department-list`}
                    className="nav-link "
                  >
                    <span>
                      <BsPersonBadgeFill />
                    </span>
                    Department
                  </Link>
                </li>

                <li
                  className={
                    lastURLSegment == "form-category-list" ? "active" : ""
                  }
                >
                  <Link
                    to={`${config.baseUrl}form-category-list`}
                    className="nav-link "
                  >
                    <span>
                      <BsFileText />
                    </span>
                    Form Category
                  </Link>
                </li>

                <li
                  className={
                    lastURLSegment == "department-forms-list" ? "active" : ""
                  }
                >
                  <Link
                    to={`${config.baseUrl}department-forms-list`}
                    className="nav-link "
                  >
                    <span>
                      <BsFolder />
                    </span>
                    Form Folders
                  </Link>
                </li>

                <li className={lastURLSegment == "master-data" ? "active" : ""}>
                  <Link to={`${config.baseUrl}master-data`} className="nav-link ">

                    <div className="d-flex flex-row align-items-center">
                      <span>
                        <BsPersonBadgeFill />
                      </span>
                      {/* <p className="mb-0 pe-5"
                        onClick={() => {
                          setOpen(!open);
                          getMasterData();
                        }}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}>
                        Master Data
                      </p> */}
                      Master Data
                      {/* <BsChevronDown /> */}
                    </div>
                  </Link>
                </li>

                <Collapse in={open}>
                  <div id="example-collapse-text">
                    {masterData.map((data) => (
                      <li
                        className={
                          lastURLSegment == "viewMasterDataList"
                            ? "active"
                            : ""
                        }
                      >
                        <a
                          href={`${config.baseUrl}viewMasterDataList/${data.id}/${data.dbTable}`}
                          className="nav-link  mastersidebar"
                        >
                          <span>
                            <BsList />
                          </span>

                          {capitalizeFirstWord(data.dbTable)}
                        </a>
                      </li>
                    ))}
                  </div>
                </Collapse>

                {/* Institution Settings - Superadmin Only */}
                {hasRole('super_admin') && (
                  <li className={lastURLSegment == "institution-settings" ? "active" : ""}>
                    <Link to={`${config.baseUrl}institution-settings`} className="nav-link ">
                      <span>
                        <BsBuilding />
                      </span>
                      Institution Settings
                    </Link>
                  </li>
                )}

                <li className={lastURLSegment == "webforms" ? "active" : ""}>
                  <Link to={`${config.baseUrl}webforms`} className="nav-link ">
                    <span>
                      <BsFileEarmarkCodeFill />
                    </span>
                    Web Form
                  </Link>
                </li>

                <li className={lastURLSegment == "patient-records" ? "active" : ""}>
                  <Link to={`${config.baseUrl}patient-records`} className="nav-link ">
                    <span>
                      <BsPeople />
                    </span>
                    Patient Records
                  </Link>
                </li>

                {/* Consents Tab - Accessible to nurse, nurse_manager, admin (school only) */}
                {canAccessConsents() && (
                  <FeatureGuard feature="sidebar.consents">
                    <li className={lastURLSegment == "consents" ? "active" : ""}>
                      <Link to={`${config.baseUrl}consents`} className="nav-link ">
                        <span>
                          <FaClipboardList />
                        </span>
                        Consents
                      </Link>
                    </li>
                  </FeatureGuard>
                )}

                {/* <li className={lastURLSegment == "medpass-dashboard" ? "active" : ""}>
                  <Link to={`${config.baseUrl}medpass-dashboard`} className="nav-link ">
                    <span>
                      <BsPrescription2 />
                    </span>
                    MedPass Workflows
                  </Link>
                </li> */}

                {/* <li>
                  <Link to="#" className="nav-link">
                    <div className="d-flex flex-row align-items-center">
                      <span>
                        <BsPersonBadgeFill />
                      </span>
                      <p
                        className="mb-0 pe-5"
                        onClick={handleClickUserManagementCms}
                        aria-controls="example-collapse-text"
                        aria-expanded={openUserManagementCms}
                      >
                        CMS
                      </p>
                      <BsChevronDown />
                    </div>
                  </Link>
                </li> */}

                {/* <Collapse in={openUserManagementCms}>
                  <div id="example-collapse-text-1">
                    <li className={lastURLSegment === "reportcontent" ? "active" : ""}>
                      <Link to={`${config.baseUrl}reportcontent`} className="nav-link">
                        <span>
                          <BsList />
                        </span>Report content
                      </Link>
                    </li>

                  </div>

                </Collapse> */}
                <li className={lastURLSegment == "logHistory" ? "active" : ""}>
                  <Link to={`${config.baseUrl}logHistory`} className="nav-link ">
                    <span>
                      <FaHistory />
                    </span>
                    Log History
                  </Link>
                </li>
              </>
            ) : null}
            
            {/* Nurse, Nurse Manager, and Physician Role Navigation */}
            {(isClinicalStaff() || hasRole('nurse_manager')) && !isAdmin() ? (
              <>
                <li className={lastURLSegment == "patient-records" ? "active" : ""}>
                  <Link to={`${config.baseUrl}patient-records`} className="nav-link ">
                    <span>
                      <BsPeople />
                    </span>
                    Patient Records
                  </Link>
                </li>

                {/* Consents Tab - Accessible to nurse and nurse_manager (school only) */}
                {(hasRole('nurse') || hasRole('nurse_manager')) && (
                  <FeatureGuard feature="sidebar.consents">
                    <li className={lastURLSegment == "consents" ? "active" : ""}>
                      <Link to={`${config.baseUrl}consents`} className="nav-link ">
                        <span>
                          <FaClipboardList />
                        </span>
                        Consents
                      </Link>
                    </li>
                  </FeatureGuard>
                )}
              </>
            ) : null}

            {/* Parent Role Navigation */}
            {hasRole('parent') ? (
              <>
                <li className={lastURLSegment == "parent-dashboard" ? "active" : ""}>
                  <Link to={`${config.baseUrl}parent-dashboard`} className="nav-link ">
                    <span>
                      <BsPeople />
                    </span>
                    My Children
                  </Link>
                </li>
                <li className={lastURLSegment == "patient-records" ? "active" : ""}>
                  <Link to={`${config.baseUrl}patient-records`} className="nav-link ">
                    <span>
                      <BsPeople />
                    </span>
                    Patient Records
                  </Link>
                </li>
              </>
            ) : null}

            <li className={lastURLSegment == "notifications" ? "active" : ""}>
              <Link to={`${config.baseUrl}notifications`} className="nav-link ">
                <span>
                  <MdNotificationsActive size={20} />
                </span>
                Notification
              </Link>
            </li>
            {/* Reporting Section - Available for Admin, Nurse, and Physician roles */}
            {isAdmin() || isClinicalStaff() ? (
              <>
                <li>
                  <div
                    className="nav-link"
                    onClick={() => setOpenReporting(!openReporting)}
                    style={{ cursor: "pointer" }}
                  >
                    <span>
                      <TbReportMedical size={20} />
                    </span>
                    Reports & Analytics
                    <span
                      className={
                        openReporting
                          ? "dropicon icondrop-up "
                          : "dropicon icondrop-down "
                      }
                    >
                      <BsChevronDown />
                    </span>
                  </div>
                </li>

                <Collapse in={openReporting}>
                  <div id="reporting-collapse">
                    <li className={lastURLSegment === "intelligent-reports" ? "active" : ""}>
                      <Link to={`${config.baseUrl}intelligent-reports`} className="nav-link">
                        <span>
                          <BsStars />
                        </span>AI Reports
                      </Link>
                    </li>

                    <FeatureGuard feature="sidebar.hemodialysis_reports">
                      <li className={lastURLSegment === "hemodialysis-reports" ? "active" : ""}>
                        <Link to={`${config.baseUrl}hemodialysis-reports`} className="nav-link">
                          <span>
                            <BsHospital />
                          </span>Hemodialysis Reports
                        </Link>
                      </li>
                    </FeatureGuard>

                    {/* Additional reports for clinical staff */}
                    {isClinicalStaff() && (
                      <>
                        <li className={lastURLSegment === "patient-reports" ? "active" : ""}>
                          <Link to={`${config.baseUrl}patient-reports`} className="nav-link">
                            <span>
                              <BsPeople />
                            </span>Patient Reports
                          </Link>
                        </li>
                        <li className={lastURLSegment === "clinical-reports" ? "active" : ""}>
                          <Link to={`${config.baseUrl}clinical-reports`} className="nav-link">
                            <span>
                              <TbReportMedical />
                            </span>Clinical Reports
                          </Link>
                        </li>
                      </>
                    )}
                  </div>
                </Collapse>
              </>
            ) : null}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;




